<template>
  <b-modal
    id="reader-select-modal"
    title="Select Card Reader to connect to"
    header-bg-variant="dark"
    header-text-variant="light"
    body-bg-variant="light"
    body-text-variant="dark"
    footer-bg-variant="light"
    no-close-on-esc
    no-close-on-backdrop
    visible
    >
    <div>
      TEST
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'ReaderSelect',
  props: ['readers'],
  data() {
    return {
    }
  },

  computed: {
  },

  methods: {

  },

  mounted() {
  },
}
</script>

<style>


</style>
